import apiService from './apiService';
import { ENDPOINTS } from '../config/api';

class HealthService {
  constructor() {
    this.intervalId = null;
    this.isRunning = false;
  }

  /**
   * Start the health check ping service
   * Pings the backend every 5 minutes to keep it alive
   */
  startHealthCheck() {
    if (this.isRunning) {
      return;
    }

    this.isRunning = true;

    // Initial ping
    this.pingBackend();

    // Set up interval for every 5 minutes (300000 ms)
    this.intervalId = setInterval(() => {
      this.pingBackend();
    }, 5 * 60 * 1000); // 5 minutes
  }

  /**
   * Stop the health check ping service
   */
  stopHealthCheck() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.isRunning = false;
    }
  }

  /**
   * Ping the backend health endpoint
   */
  async pingBackend() {
    try {
      // Use the centralized apiService and skip the global error handler for this background check
      await apiService.get(ENDPOINTS.HEALTH, { skipErrorHandler: true });
    } catch (error) {
      // Silently log the error without showing a user-facing toast
      console.error('Health check ping failed:', error);
    }
  }

  /**
   * Get the current status of the health check service
   */
  isHealthCheckRunning() {
    return this.isRunning;
  }
}

// Create a singleton instance
const healthService = new HealthService();

export default healthService;